var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Building, Infrastructure / Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3542 3.625H19.3334C18.9997 3.625 18.7292 3.8955 18.7292 4.22917V4.30035L22.9584 7.68368V4.22917C22.9584 3.8955 22.6879 3.625 22.3542 3.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9896 11.4792C12.9896 10.645 13.6659 9.96875 14.5 9.96875C15.3342 9.96875 16.0104 10.645 16.0104 11.4792C16.0104 12.3134 15.3342 12.9896 14.5 12.9896C13.6659 12.9896 12.9896 12.3134 12.9896 11.4792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0729 13.2439L26.0172 13.9994C26.4081 14.312 26.9784 14.2487 27.2911 13.8578C27.6037 13.467 27.5404 12.8967 27.1495 12.584L17.3307 4.72896C15.6758 3.40504 13.3243 3.40504 11.6694 4.72896L1.85059 12.584C1.45976 12.8967 1.39639 13.467 1.70906 13.8578C2.02172 14.2487 2.59201 14.312 2.98285 13.9994L3.92714 13.2439V25.6771H2.41672C1.91621 25.6771 1.51047 26.0828 1.51047 26.5833C1.51047 27.0838 1.91621 27.4896 2.41672 27.4896H26.5834C27.0838 27.4896 27.4896 27.0838 27.4896 26.5833C27.4896 26.0828 27.0838 25.6771 26.5834 25.6771H25.0729V13.2439ZM11.1771 11.4792C11.1771 9.64398 12.6648 8.15626 14.5 8.15626C16.3352 8.15626 17.8229 9.64398 17.8229 11.4792C17.8229 13.3144 16.3352 14.8021 14.5 14.8021C12.6648 14.8021 11.1771 13.3144 11.1771 11.4792ZM14.5597 16.0104C15.3631 16.0104 16.0553 16.0103 16.6096 16.0849C17.2037 16.1647 17.7732 16.3449 18.235 16.8067C18.6969 17.2687 18.877 17.838 18.9568 18.4322C19.0267 18.9517 19.031 19.5926 19.0313 20.3326C19.0313 20.3821 19.0313 20.4318 19.0313 20.482V25.6771H17.2188V20.5417C17.2188 19.6616 17.2168 19.0928 17.1605 18.6736C17.1077 18.2805 17.0224 18.1574 16.9534 18.0884C16.8844 18.0194 16.7612 17.9341 16.3681 17.8812C15.9489 17.8249 15.38 17.8229 14.5 17.8229C13.62 17.8229 13.0511 17.8249 12.6321 17.8812C12.239 17.9341 12.1157 18.0194 12.0467 18.0884C11.9777 18.1574 11.8924 18.2805 11.8396 18.6736C11.7832 19.0928 11.7813 19.6616 11.7813 20.5417V25.6771H9.9688V20.482C9.96876 19.6787 9.96872 18.9864 10.0432 18.4322C10.1231 17.838 10.3032 17.2687 10.7651 16.8067C11.227 16.3449 11.7964 16.1647 12.3905 16.0849C12.9448 16.0103 13.637 16.0104 14.4404 16.0104H14.5597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9896 11.4792C12.9896 10.645 13.6659 9.96875 14.5 9.96875C15.3342 9.96875 16.0104 10.645 16.0104 11.4792C16.0104 12.3134 15.3342 12.9896 14.5 12.9896C13.6659 12.9896 12.9896 12.3134 12.9896 11.4792Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home_white.83b5c5f70b8942cd363366565a6dcf07.svg";
export { ForwardRef as ReactComponent };